import React from 'react';

import { H1, P } from '@styles/Typography';

import Button from '@components/Button';

import * as S from './styles';

const IntroTemplate = () => {
	return (
		<S.Wrapper>
			<S.Box>
				<S.LogoWrapper>
					<S.Logo />
				</S.LogoWrapper>

				<H1>Boas-vindas!</H1>
				<P>Escolha a opção abaixo que mais se adequa a você.</P>

				<Button to="/paciente" outlined>
					Sou cliente
				</Button>

				<Button to="/medico" outlined>
					Sou médica(o)
				</Button>
			</S.Box>
		</S.Wrapper>
	);
};

export default IntroTemplate;
